<template>
	<div v-if="form.amount && form.gateway !== 'check' && form.gateway !== 'wire'">
		<div class="fee-info-container fee-heb" v-if="lang == 'he'">  
      על ידי כיסוי עמלות העסקה, אתה מבטל לחלוטין את התקורה של עיבוד התשלומים של {{form.applications[0].department.replace(/_/g, ' ')}} ומאפשר להם לקבל 100% מהתרומה המיועדת שלך.        
			<br/>
			<div class="flex">
				<input type="checkbox" id="cover" :value="form.handleProcessing" @change="setValue('handleProcessing', $event.target.checked)"/>
        <label for="cover" style=" font-size: inherit; ">
          כן, כלול עמלת עסקה של
				  <span class="amount">{{ form.currency === 'ILS' ? '₪' : '$' }}{{ (parseInt(form.amount) * feePercent / 100).toFixed(2) }}</span>
				  כך ש-100% מהתרומה שלך עוברת {{form.applications[0].department.replace(/_/g, ' ')}}
        </label>
			</div>
		</div>
		<div class="fee-info-container" v-else>      
			By covering the transaction fees, you are completely eliminating {{dept ? dept : form.applications[0].department.replace(/_/g, ' ')}} payment processing overhead and enabling them to receive 100% of your intended donation.
			<br/>
			<div class="flex">
				<input type="checkbox" id="cover" :value="form.handleProcessing" @change="setValue('handleProcessing', $event.target.checked)"/>
				<FormLabel for="cover">
          Yes, include a transaction fee of
				  <span class="amount">{{ form.currency === 'ILS' ? '₪' : '$' }}{{ (parseInt(form.amount) * feePercent / 100).toFixed(2) }}</span>
				  so that 100% of your donation goes to {{dept ? dept : form.applications[0].department.replace(/_/g, ' ')}}
        </FormLabel>
			</div>
		</div>
	</div>
</template>
<script lang="ts">
import { defineComponent,  ref, watch } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

export default defineComponent({
  props: {
		lang: {
      type: String
    },
		dept: {
      type: String
    },
  },
  setup() {
    const feePercent = 2.5
    const { form, setValue } = usePaymentForm()

    return {
      feePercent,
      form,
      setValue,
    }
  },
})
</script>
<style scoped lang="scss">
input[type='checkbox'] {
  margin-right: 7px;
}
.amount {
  font-weight: bold;
  display: inline-block;
}
.inline-block {
  display: inline-block;
}
.edit {
  color: #0075ff;
  cursor: pointer;
  margin-left: auto;
  text-decoration: underline;
}
.fee-info-container {
  background: #f2f5f8;
  padding: 15px;
  border-radius: 4px;
  margin-top: 15px;
  line-height: 1.4;
  font-size: 13px;
}
::v-deep label {
  font-size: 13px;
}
.flex {
  display: flex;
  margin-top: 10px;

  input {
    margin-top: 4px;
  }
}

::v-deep .fee-heb{

}
</style>